import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { Quote, Vehicle } from '@sm360/widget-commons-vehicle';
import { ADOBE_TAGS, AdobeService, EVENTS } from '@sm360/widget-commons-general';

const marketPlaceOrgId = 481;

const { VehicleTitleSpecs } = Vehicle;

const VehicleTitle = ({ quote, vehicle, deleteQuote, isMultiDealerGarage, hasAdobeTagging }) => {
    const isInApprovalStatus = quote.isQuoteInApproval();
    const isQuoteInPending = quote.isQuoteInPending();
    const isQuoteDelivered = quote.isQuoteDelivered();
    const isCatalogDeskingQuote = quote.isCatalogDeskingQuote();
    const pendingTransKey = isInApprovalStatus ? 'GARAGE.PENDING_APPROVAL' : 'GARAGE.PENDING_TRANSACTIONS';
    const completedTransKey = isQuoteDelivered && 'GARAGE.COMPLETED_TRANSACTION';
    const isAvailable = isQuoteInPending || vehicle.isAvailable();

    const props = {
        vehicle,
        url:
            isAvailable && !isCatalogDeskingQuote
                ? quote.getVDPUrl(false, isMultiDealerGarage && quote?.orgId === marketPlaceOrgId, quote?.orgUnitId)
                : '',
        className: 'vehicle-title-header sr-text is-bold',
        isAvailable,
    };

    const titleBody = [<VehicleTitleSpecs {...props} />];

    const dispatchRemoveEvent = () => {
        const $window = WindowProxy.get();
        if ($window) {
            $window.document.dispatchEvent(
                new CustomEvent(EVENTS.GARAGE_REMOVED, {
                    detail: {
                        quoteId: quote?.id,
                    },
                })
            );
        }
    };

    const handleClick = () => {
        if (hasAdobeTagging) {
            AdobeService.eventTrigger(ADOBE_TAGS.GARAGE_OVERLAY_CTA('delete', quote?.vehicle), 'global-onclick');
        }
        deleteQuote(quote, isMultiDealerGarage);
        dispatchRemoveEvent();
    };

    if (!isQuoteInPending && !isInApprovalStatus) {
        const deleteButton = (
            <button className="vehicle-delete" onClick={handleClick}>
                <p className="vehicle-delete__label">{LocaleService.t('GARAGE.REMOVE_VEHICLE')}</p>
                <icon className="icon-trash-can" />
            </button>
        );
        titleBody.push(deleteButton);
    } else {
        titleBody.push(
            <p className="vehicle-transaction">
                {LocaleService.t(isQuoteDelivered ? completedTransKey : pendingTransKey)}
            </p>
        );
    }

    return <div className="vehicle-title__wrapper">{titleBody}</div>;
};

VehicleTitle.defaultProps = { isMultiDealerGarage: false, hasAdobeTagging: false };

VehicleTitle.propTypes = {
    deleteQuote: PropTypes.func.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModel).isRequired,
    isMultiDealerGarage: PropTypes.bool.isRequired,
    hasAdobeTagging: PropTypes.bool,
};

VehicleTitle.displayName = 'VehicleTitle';

export default VehicleTitle;
